{
  "version": 1,
  "asset_id": "6e4c660c-1033-406d-961c-97a2c5a76075",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/6e4c660c-1033-406d-961c-97a2c5a76075/danny-main-logo-800.webp",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/6e4c660c-1033-406d-961c-97a2c5a76075/danny-main-logo-800.webp",
  "original_filename": "danny-main-logo-800.webp",
  "size": 29104,
  "content_type": "image/webp",
  "created_at": "2026-07-17T19:00:08Z"
}
